<template>
  <sign-up-carousel-wrapper>
    <template #img>
      <img
        height="392"
        src="@/assets/img/signup-carousel-first@2x.png"
        alt=""
      />
    </template>
    <template #title>{{ $t("SignUp_Carousel_Title1") }}</template>
    <template #caption>
      {{ $t("SignUp_Carousel_Caption1") }}
    </template>
  </sign-up-carousel-wrapper>
</template>

<script>
import SignUpCarouselWrapper from "./SignUpCarouselWrapper.vue";

export default {
  components: { SignUpCarouselWrapper },
};
</script>

<style></style>
